import { render, staticRenderFns } from "./CSCAnswerDlg.vue?vue&type=template&id=630801c8&"
import script from "./CSCAnswerDlg.vue?vue&type=script&lang=js&"
export * from "./CSCAnswerDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports